module.exports = __webpack_public_path__ + "static/media/up-w.0bdc4685.svg";